import axios from "axios";
import { UniaGAVConstants } from "@/assets/configuration/constants.js";

export {
  getAuthHeader,
  GetAllUsers,
  GetUser,
  CreateNewUser,
  UpdateUser,
  GetRoles,
  UpdateUserPassword,
  Logout,
  Login,
  UpdatePassword,
  IsUserLoggedIn,
  GetCurrentUserName,
  IsUserInRole,
  RefreshToken,
  DeleteUser,
  GetActivedirectoryUsers,
  GetStatuspageInfo
};

function getAuthHeader() {
  var headerKeyValue = getAuthorizationHeaderKeyValue();
  headerKeyValue["X-Requested-With"] = "XMLHttpRequest";

  var config = {
    headers: headerKeyValue
  };

  return config;
}

function getAuthorizationHeaderKeyValue() {
  let user = JSON.parse(
    localStorage.getItem(UniaGAVConstants.LocalStorageKeys.Authentication)
  );

  if (user && user.token) {
    return {
      Authorization: "Bearer " + user.token
    };
  } else {
    return {};
  }
}

function GetActivedirectoryUsers(onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .get(
      process.env.VUE_APP_BASE_API_URL + "/users/activedirectoryusers",
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}

function GetAllUsers(onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .get(process.env.VUE_APP_BASE_API_URL + "/users", headers)
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}

function CreateNewUser(newUser, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .post(process.env.VUE_APP_BASE_API_URL + "/users/", newUser, headers)
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}

function GetUser(userId, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .get(process.env.VUE_APP_BASE_API_URL + "/users/" + userId, headers)
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}

function DeleteUser(userId, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .delete(process.env.VUE_APP_BASE_API_URL + "/users/" + userId, headers)
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}

function UpdateUser(userId, userObject, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .put(
      process.env.VUE_APP_BASE_API_URL + "/users/" + userId,
      userObject,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}

function UpdateUserPassword(userId, passwordObject, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .post(
      process.env.VUE_APP_BASE_API_URL +
        "/manage/users/" +
        userId +
        "/password",
      passwordObject,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}

function GetRoles(onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .get(process.env.VUE_APP_BASE_API_URL + "/roles", headers)
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}

function Login(username, password, onSuccess, onError) {
  var requestData = {
    email: username,
    password: password,
    rememberMe: true
  };

  axios
    .post(process.env.VUE_APP_BASE_API_URL + "/account/login", requestData)
    .then(response => {
      localStorage.setItem(
        UniaGAVConstants.LocalStorageKeys.Authentication,
        JSON.stringify(response.data)
      );

      onSuccess(response);
    })
    .catch(error => {
      onError(error);
    });
}

function UpdatePassword(
  oldPassword,
  newPassword,
  newPasswordConfirm,
  onSuccess,
  onError
) {
  var headers = getAuthHeader();

  var requestData = {
    oldPassword: oldPassword,
    newPassword: newPassword,
    confirmPassword: newPasswordConfirm,
    statusMessage: ""
  };

  axios
    .post(
      process.env.VUE_APP_BASE_API_URL + "/manage/change-password",
      requestData,
      headers
    )
    .then(response => {
      onSuccess(response);
    })
    .catch(error => {
      onError(error);
    });
}

function Logout() {
  var headers = getAuthHeader();

  axios
    .get(process.env.VUE_APP_BASE_API_URL + "/account/logout", headers)
    .then(() => {
      // nothing needs to be done.
    })
    .catch(() => {
      // nothing needs to be done
      // it does not matter if this fails, the session will be terminated after 30 minutes anyway.
    });

  localStorage.removeItem(UniaGAVConstants.LocalStorageKeys.Authentication);
}

function RefreshToken() {
  var headers = getAuthHeader();

  axios
    .get(process.env.VUE_APP_BASE_API_URL + "/account/refresh", headers)
    .then(response => {
      localStorage.setItem(
        UniaGAVConstants.LocalStorageKeys.Authentication,
        JSON.stringify(response.data)
      );
    })
    .catch(() => {
      Logout();
    });
}

function GetStatuspageInfo(onSuccess, onError) {
  axios
    .get("https://www.int.gav-service.ch/statuspage/status/GetStausAdmin")
    .then(response => {
      if (response.data) {
        onSuccess(response.data);
      }
    })
    .catch(error => {
      onError(error);
    });
}

function IsUserLoggedIn() {
  let user = JSON.parse(
    localStorage.getItem(UniaGAVConstants.LocalStorageKeys.Authentication)
  );
  return user != null;
}

function GetCurrentUserName() {
  let user = JSON.parse(
    localStorage.getItem(UniaGAVConstants.LocalStorageKeys.Authentication)
  );
  if (user != null) {
    return user.user;
  }

  return "";
}

function IsUserInRole(userRole) {
  let user = JSON.parse(
    localStorage.getItem(UniaGAVConstants.LocalStorageKeys.Authentication)
  );
  if (user != null) {
    if (user.roles.indexOf(userRole) != -1) {
      return true;
    }
  }

  return false;
}
